import { useResearchStudioStore } from "@/stores/ResearchStudioStore";
import { useMapStore } from "@/stores/MapStore";

export const ResearchStudioStores = [useResearchStudioStore, useMapStore];

export const ResearchStudioChannel = {
  async received(payload) {
    if (payload.id === this.researchStudioStore.taskIds.surveyDataSingle) {
      if (payload.status === "error") {
        this.researchStudioStore.errors.surveyDataSingle = payload.message;
        this.researchStudioStore.taskIds.surveyDataSingle = undefined;
        this.researchStudioStore.loading.surveyDataSingle = false;
        this.researchStudioStore.surveyDataSingle = undefined;
        return;
      }
      this.researchStudioStore.surveyDataSingle = payload.data.results;
      this.researchStudioStore.taskIds.surveyDataSingle = undefined;
      this.researchStudioStore.loading.surveyDataSingle = false;
    }
    if (payload.id === this.researchStudioStore.taskIds.surveyDataTrended) {
      if (payload.status === "error") {
        this.researchStudioStore.errors.surveyDataTrended = payload.message;
        this.researchStudioStore.taskIds.surveyDataTrended = undefined;
        this.researchStudioStore.loading.surveyDataTrended = false;
        this.researchStudioStore.surveyDataTrended = undefined;
        return;
      }
      this.researchStudioStore.surveyDataTrended = payload.data.results;
      this.researchStudioStore.taskIds.surveyDataTrended = undefined;
      this.researchStudioStore.loading.surveyDataTrended = false;
    }
    if (
      payload.id ===
      this.researchStudioStore.taskIds.surveyDataTrendedQuestionId
    ) {
      if (payload.status === "error") {
        this.researchStudioStore.errors.surveyDataTrendedQuestionId = {
          question_id: payload.data.results[0].question_id,
          message:
            "Something went wrong. Please update the Trend Variables and try again.",
        };
        this.researchStudioStore.taskIds.surveyDataTrendedQuestionId =
          undefined;
        this.researchStudioStore.loading.surveyDataTrendedQuestionId = false;
        this.researchStudioStore.surveyDataTrendedQuestionId = undefined;
        return;
      }
      const questionId = payload.data.results[0].question_id;
      this.researchStudioStore.surveyDataTrended =
        this.researchStudioStore.surveyDataTrended.map((question) => {
          if (question.question_id === questionId) {
            return { ...payload.data.results[0] };
          }
          return question;
        });
      this.researchStudioStore.taskIds.surveyDataTrendedQuestionId = undefined;
      this.researchStudioStore.loading.surveyDataTrendedQuestionId = undefined;
    }
    if (payload.id === this.researchStudioStore.taskIds.modeledDataSingle) {
      if (payload.status === "error") {
        this.researchStudioStore.errors.modeledDataSingle = payload.message;
        this.researchStudioStore.taskIds.modeledDataSingle = undefined;
        this.researchStudioStore.loading.modeledDataSingle = false;
        this.researchStudioStore.modeledDataSingle = undefined;
        return;
      }
      this.researchStudioStore.modeledDataSingle = payload.data.results;
      this.researchStudioStore.taskIds.modeledDataSingle = undefined;
      this.researchStudioStore.loading.modeledDataSingle = false;
    }
    if (payload.id === this.researchStudioStore.taskIds.modeledDataTrended) {
      if (payload.status === "error") {
        this.researchStudioStore.errors.modeledDataTrended = payload.message;
        this.researchStudioStore.taskIds.modeledDataTrended = undefined;
        this.researchStudioStore.loading.modeledDataTrended = false;
        this.researchStudioStore.modeledDataTrended = undefined;
        return;
      }
      this.researchStudioStore.modeledDataTrended = payload.data.results;
      this.researchStudioStore.taskIds.modeledDataTrended = undefined;
      this.researchStudioStore.loading.modeledDataTrended = false;
    }
    if (payload.id === this.researchStudioStore.taskIds.aiSummary) {
      if (payload.status === "error") {
        this.researchStudioStore.errors.aiSummary = payload.message;
        this.researchStudioStore.taskIds.aiSummary = undefined;
        this.researchStudioStore.loading.aiSummary = false;
        return;
      }
      this.researchStudioStore.aiSummary = payload.data.summary;
      this.researchStudioStore.taskIds.aiSummary = undefined;
      this.researchStudioStore.loading.aiSummary = false;
    }
    // All export types share one workflow: match the task id, then download the
    // standardized `payload.data.files`. Handled by the shared export manager.
    this.researchStudioStore.handleExportMessage(payload);
  },
};
